import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

/** Mode démonstration (`?demo`) : données fictives en mémoire, sans serveur ni compte. Jamais de donnée réelle. */
export const isDemoSearch = (search: string): boolean => new URLSearchParams(search).has('demo');

/** Construit la cible d'un lien en gardant `?demo` : sans cela, le premier clic quitterait la démonstration. */
export function useAppTo(): (path: string) => string {
  const { search } = useLocation();
  const demo = isDemoSearch(search);
  return useCallback((path: string) => (demo ? `${path}?demo` : path), [demo]);
}
